<p-fieldset legend="Veículos de comunicação">
  <div class="row">
    <div class="col-12">
      <button (click)="adicionar()" class="btn btn-sm btn-outline-primary" [disabled]="itemAtual">
        <i class="fa fa-plus"></i> Adicionar
      </button>
    </div>
  </div>
  <table class="table table-eddy table-sm">
    <thead>
      <tr>
        <th style="width: 35%" scope="col">Veículo</th>
        <th style="width: 15%" scope="col">Data/Atos oficiais</th>
        <th style="width: 40%" scope="col">Descrição</th>
        <th style="width: 10%" scope="col"></th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of entidade[campo]">
        <td style="width: 35%">
          <span *ngIf="!item.editavel">{{item.VeiculoPublicacao}} - {{funcaoService.obterObjetoPorChave(opcoesVeiculo,
            item.VeiculoPublicacao).nome}}</span>
          <select *ngIf="item.editavel" [compareWith]="compareFn" id="modalidade" class="form-control"
            [(ngModel)]="itemAtual.VeiculoPublicacao" [ngModelOptions]="{standalone: true}">
            <option *ngFor="let item of opcoesVeiculo" [ngValue]="item.id">{{item.nome}}</option>
          </select>
        </td>

        <td style="width: 15%">
          <span *ngIf="!item.editavel" class="d-block">{{item.PublicacaoData}}</span>
          <span *ngIf="!item.editavel">{{item.PublicacaoOficial}}</span>
          <p-calendar (onFocus)="onFocusDate()"*ngIf="item.editavel" [(ngModel)]="itemAtual.PublicacaoData" [ngModelOptions]="{standalone: true}"
            inputStyleClass="form-control d-block" dataType="string" dateFormat="dd/mm/yy" [showOnFocus]="true">
          </p-calendar>
          <p-selectButton *ngIf="item.editavel" [options]="opcoesSimNao" optionValue="id"
            [(ngModel)]="itemAtual.PublicacaoOficial" [ngModelOptions]="{standalone: true}" class="text-center">
            <ng-template let-opcao>
              <span class="p-1" style="font-size: 0.8rem;">{{opcao.nome}}</span>
            </ng-template>
          </p-selectButton>
        </td>

        <td style="width: 40%">
          <span *ngIf="!item.editavel">
            {{item.PublicacaoDescr}}
          </span>
          <textarea *ngIf="item.editavel" class="form-control" rows="3" [(ngModel)]="itemAtual.PublicacaoDescr"
            [ngModelOptions]="{standalone: true}"></textarea>
        </td>

        <td style="width: 10%" class="text-right">
          <button *ngIf="!item.editavel" (click)="visualizar(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/pencil.png" alt="editar" height="16" width="16">
          </button>
          <button *ngIf="!item.editavel" (click)="remover(item)" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/bin_closed.png" alt="remover" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="salvar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/tick.png" alt="salvar" height="16" width="16">
          </button>
          <button *ngIf="item.editavel" (click)="cancelar()" class="btn btn-sm btn-outline-primary mr-2">
            <img src="assets/img/global/cross.png" alt="cancelar" height="16" width="16">
          </button>
        </td>
      </tr>
    </tbody>
  </table>
</p-fieldset>